import { render, staticRenderFns } from "./DFieldFile.vue?vue&type=template&id=1fa00ce2&scoped=true&"
import script from "./DFieldFile.vue?vue&type=script&lang=js&"
export * from "./DFieldFile.vue?vue&type=script&lang=js&"
import style0 from "./DFieldFile.vue?vue&type=style&index=0&id=1fa00ce2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa00ce2",
  null
  
)

export default component.exports